import React from "react";

const MAP = {
  ACTIVE: { bg: "rgba(0,255,102,0.12)", color: "#00FF66", label: "ACTIVE" },
  PENDING: { bg: "rgba(245,158,11,0.14)", color: "#F59E0B", label: "PENDING" },
  SUSPENDED: { bg: "rgba(239,68,68,0.14)", color: "#F87171", label: "SUSPENDED" },
  EXPIRED: { bg: "rgba(148,163,184,0.14)", color: "#94A3B8", label: "EXPIRED" },
  NONE: { bg: "rgba(148,163,184,0.12)", color: "#94A3B8", label: "NONE" },
  APPROVED: { bg: "rgba(0,255,102,0.12)", color: "#00FF66", label: "APPROVED" },
  REJECTED: { bg: "rgba(239,68,68,0.14)", color: "#F87171", label: "REJECTED" },
  "PENDING VERIFICATION": { bg: "rgba(245,158,11,0.14)", color: "#F59E0B", label: "PENDING" },
  OPEN: { bg: "rgba(59,130,246,0.14)", color: "#60A5FA", label: "OPEN" },
};

export const StatusBadge = ({ status, testid }) => {
  const s = MAP[status] || MAP.NONE;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold font-mono tracking-wide"
      style={{ background: s.bg, color: s.color }} data-testid={testid}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
};

export const PredictionPill = ({ prediction }) => {
  const color = prediction === "HOME WIN" ? "#00FF66" : prediction === "DRAW" ? "#F59E0B" : "#3B82F6";
  return (
    <span className="inline-block px-3 py-1 rounded-lg text-sm font-display font-extrabold tracking-wide"
      style={{ background: `${color}1f`, color }}>
      {prediction}
    </span>
  );
};
